import { LEGAL, type LegalSet } from './meta';

const { company: C, email: E } = LEGAL;

export const ro: LegalSet = {
  privacy: {
    title: 'Politica de confidențialitate',
    intro: `Această politică explică ce date cu caracter personal colectează ${C} („noi”) atunci când folosești site-ul, editorul și API-ul („Serviciul”), de ce le colectăm și ce drepturi ai.`,
    sections: [
      {
        h: '1. Datele pe care le colectăm',
        p: [
          'Datele contului: numele, adresa de email, hash-ul parolei, limba interfeței și — dacă te autentifici cu Google — ID-ul contului tău Google și adresa de email verificată.',
          'Conținut: șabloanele, imaginile, fonturile, tabelele și alte fișiere pe care le încarci, datele pe care le trimiți către API pentru generarea imaginilor, precum și imaginile generate.',
          'Date de utilizare: generări, rulări ale automatizărilor, solicitări AI, chei API (stocate sub formă de hash), sesiuni de autentificare, adresa IP și user agent-ul browserului, jurnale de erori.',
          'Date de facturare: planul, starea abonamentului și identificatorii plăților. Datele cardului sunt procesate de furnizorul de plăți (Lemon Squeezy sau Stripe) și nu ajung niciodată pe serverele noastre.',
        ],
      },
      {
        h: '2. Cum folosim datele',
        p: [
          'Pentru a furniza Serviciul: stocarea șabloanelor tale, generarea imaginilor, rularea automatizărilor și livrarea rezultatelor către integrările pe care le conectezi.',
          'Pentru a menține Serviciul sigur și fiabil: autentificare, prevenirea abuzurilor, limitarea numărului de cereri, depanare și copii de rezervă.',
          'Pentru facturare și aplicarea limitelor planului, precum și pentru trimiterea emailurilor de serviciu (resetarea parolei, invitații, modificări importante). Nu trimitem emailuri de marketing fără consimțământul tău.',
        ],
      },
      {
        h: '3. Temeiuri juridice',
        p: [
          'Prelucrăm datele pentru executarea contractului încheiat cu tine, pentru respectarea obligațiilor legale și în baza interesului nostru legitim de a opera un serviciu sigur. Acolo unde legea o cere, îți solicităm consimțământul.',
        ],
      },
      {
        h: '4. Funcționalitățile AI',
        p: [
          'Când folosești generarea cu AI, descrierea sau textul introdus este trimis furnizorului nostru de AI (Google Gemini API) pentru a obține rezultatul. Nu trimitem celelalte șabloane sau fișiere ale tale. Furnizorul prelucrează aceste date conform propriilor condiții și nu folosește traficul API plătit pentru antrenarea modelelor sale.',
        ],
      },
      {
        h: '5. Divulgarea datelor',
        p: [
          'Nu vindem date cu caracter personal. Le partajăm doar cu persoanele împuternicite care ne ajută să operăm Serviciul — găzduire și stocare, plăți (Lemon Squeezy, Stripe), livrarea emailurilor, generare AI (Google) — și cu integrările pe care le conectezi tu însuți (Google Drive, Sheets, S3, webhookuri).',
          'Putem divulga date atunci când legea o impune sau pentru a ne proteja utilizatorii și Serviciul.',
          'Unele persoane împuternicite (de exemplu Google) pot prelucra date în afara SEE. Aceste transferuri se bazează pe EU–US Data Privacy Framework sau pe Clauzele contractuale standard ale Comisiei Europene.',
        ],
      },
      {
        h: '6. Perioada de păstrare',
        p: [
          'Păstrăm datele contului și conținutul cât timp contul tău este activ. Imaginile generate și jurnalele sunt păstrate în funcție de planul și setările tale. După ștergerea unui spațiu de lucru sau a contului, datele sunt șterse în termen de 30 de zile, cu excepția cazurilor în care legea ne obligă să le păstrăm mai mult timp (de exemplu, facturile).',
        ],
      },
      {
        h: '7. Cookie-uri',
        p: [
          'Cookie-uri esențiale (fără consimțământ): cookie-ul de sesiune care te menține autentificat și un cookie de scurtă durată pentru autentificarea cu Google. Limba, spațiul de lucru selectat și alegerea ta privind cookie-urile sunt stocate în browser.',
          'Cookie-uri de analiză — doar cu acordul tău: Google Analytics 4 (Google Ireland Ltd.) măsoară vizitele cu identificatori pseudonimi în cookie-urile _ga (până la 2 ani); Google păstrează datele 14 luni, iar Google Signals și funcțiile de publicitate sunt dezactivate. Analiza nu se încarcă până nu o accepți în bannerul de cookie-uri și îți poți retrage oricând acordul din „Setări cookie” din subsolul site-ului sau din profil. Nu folosim cookie-uri de publicitate.',
        ],
      },
      {
        h: '8. Securitate',
        p: [
          'Parolele și cheile API sunt stocate sub formă de hash, datele de acces pentru integrări sunt criptate, iar traficul este protejat prin HTTPS. Niciun sistem nu este perfect sigur, dar luăm măsuri rezonabile pentru a-ți proteja datele.',
        ],
      },
      {
        h: '9. Drepturile tale',
        p: [
          `Ai dreptul de acces, rectificare, ștergere, restricționare, portabilitate și opoziție (art. 15–21 GDPR). În Setări → Profil poți descărca o copie a datelor și îți poți șterge singur contul. De asemenea, te poți opune prelucrării, îți poți retrage consimțământul și poți depune o plângere la autoritatea de protecție a datelor. Pentru a-ți exercita drepturile, scrie-ne la ${E}.`,
        ],
      },
      {
        h: '10. Copiii',
        p: [
          'Serviciul nu este destinat persoanelor cu vârsta sub 16 ani și nu colectăm în mod intenționat datele acestora.',
        ],
      },
      {
        h: '11. Modificări și contact',
        p: [
          `Vom publica modificările pe această pagină și te vom anunța prin email cu privire la cele semnificative. Întrebări despre confidențialitate: ${E}.`,
        ],
      },
    ],
  },
  terms: {
    title: 'Termeni și condiții',
    intro: `Acești termeni reglementează utilizarea ${C} („Serviciul”). Prin crearea unui cont sau prin utilizarea Serviciului, ești de acord cu ei. Dacă folosești Serviciul în numele unei companii, îi accepți în numele acesteia.`,
    sections: [
      {
        h: '1. Serviciul',
        p: [
          'Serviciul îți permite să creezi șabloane de imagini, să generezi imagini prin editor, API și automatizări și să folosești funcționalități AI. Putem modifica și îmbunătăți funcționalitățile în timp.',
        ],
      },
      {
        h: '2. Contul',
        p: [
          'Trebuie să furnizezi informații corecte și să păstrezi confidențialitatea parolei și a cheilor API. Ești responsabil pentru tot ce se face prin contul și spațiile tale de lucru. Anunță-ne imediat dacă suspectezi un acces neautorizat.',
        ],
      },
      {
        h: '3. Planuri, plată și anulare',
        p: [
          'Planurile plătite sunt facturate în avans, lunar sau anual, și se reînnoiesc automat. Plățile sunt procesate de revânzătorul nostru Lemon Squeezy (comerciantul înregistrat, care se ocupă și de taxele pe vânzări) sau de Stripe. Îți trimitem un memento prin email cu câteva zile înainte de fiecare reînnoire și o chitanță după aceasta. Limitele de utilizare pentru fiecare plan sunt afișate pe pagina de prețuri; când o limită este atinsă, acțiunile aferente sunt suspendate până la perioada următoare sau până la trecerea la un plan superior.',
          'Dacă plata pentru reînnoire eșuează, planul continuă să funcționeze câteva zile, timp în care poți actualiza metoda de plată; dacă plata tot nu reușește, spațiul de lucru trece pe planul Free. Șabloanele și fișierele tale se păstrează.',
          'Poți anula oricând: planul rămâne activ până la sfârșitul perioadei plătite și nu se mai reînnoiește. Plățile nu sunt rambursabile, cu excepția cazurilor prevăzute de lege. Putem modifica prețurile cu o notificare prealabilă de cel puțin 30 de zile.',
        ],
      },
      {
        h: '4. Conținutul tău',
        p: [
          'Păstrezi toate drepturile asupra șabloanelor, fișierelor și datelor pe care le încarci și asupra imaginilor pe care le generezi. Ne acorzi o licență limitată de a stoca, prelucra și afișa acest conținut exclusiv pentru a-ți furniza Serviciul.',
          'Ești responsabil să deții drepturile asupra conținutului pe care îl folosești, inclusiv imagini, fonturi, logouri și mărci comerciale.',
        ],
      },
      {
        h: '5. Utilizare acceptabilă',
        p: [
          'Nu ai voie să folosești Serviciul pentru a crea sau distribui conținut ilegal, conținut care încalcă drepturile altora, programe malițioase, spam sau materiale înșelătoare, conținut care exploatează minori ori pentru a hărțui alte persoane.',
          'Nu ai voie să încerci să compromiți sau să supraîncarci Serviciul, să ocolești limitele sau măsurile de securitate ori să revinzi accesul fără permisiunea noastră. Putem suspenda conturile care încalcă aceste reguli.',
        ],
      },
      {
        h: '6. Funcționalitățile AI',
        p: [
          'Rezultatele AI sunt generate automat și pot fi inexacte sau asemănătoare cu rezultatele generate pentru alți utilizatori. Verifică-le înainte de publicare; ești responsabil pentru modul în care le folosești.',
        ],
      },
      {
        h: '7. Planul Free și previzualizările',
        p: [
          'Generările de previzualizare sunt gratuite și au întotdeauna filigran. Planul Free este oferit „ca atare”, iar limitele sale se pot modifica.',
        ],
      },
      {
        h: '8. Disponibilitate',
        p: [
          'Urmărim o disponibilitate ridicată, dar nu garantăm că Serviciul va funcționa neîntrerupt sau fără erori. Păstrează copii ale datelor importante; poți exporta oricând șabloanele.',
        ],
      },
      {
        h: '9. Limitarea răspunderii',
        p: [
          'Serviciul este furnizat „ca atare”. În măsura permisă de lege, nu răspundem pentru daune indirecte, profituri nerealizate sau pierderi de date, iar răspunderea noastră totală este limitată la suma pe care ne-ai plătit-o în cele 12 luni anterioare reclamației.',
        ],
      },
      {
        h: '10. Încetarea',
        p: [
          'Îți poți șterge oricând spațiile de lucru și poți înceta oricând să folosești Serviciul. Putem suspenda sau înceta accesul în caz de încălcare a acestor termeni sau de neplată; acolo unde este posibil, te vom anunța în prealabil și îți vom permite să îți exporți datele.',
        ],
      },
      {
        h: '11. Modificări și contact',
        p: [
          `Putem actualiza acești termeni; te vom anunța în prealabil cu privire la modificările semnificative. Continuarea utilizării Serviciului după intrarea în vigoare a modificărilor înseamnă că le accepți. Întrebări: ${E}.`,
        ],
      },
    ],
  },
};
